import styled from 'styled-components';
import AimsosLogo from './assets/AIMSOS.svg';

const ContainerWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme?.colors?.background || '#0B1020'};
`;

const LoadingBox = styled.img.attrs({
  src: AimsosLogo,
  alt: 'AIMSOS loading',
})`
  width: 120px;
  height: auto;
`;

export { ContainerWrapper, LoadingBox };